import canAutoPlay from 'can-autoplay';
import Cookies from 'js-cookie';

import $ from 'jquery';

export default class HomePageVideoController {
  constructor(element) {

    this.is_mobile = this.mobilecheck();

    if (this.is_mobile) {
      document.body.classList.add('is_mobile');
    }

    //just once, bye
    Cookies.set('video_seen_cookie', 'aye aye captain!', { expires: 28 });

    this.element = element;
    this.isShowingFullScreen = false;

    document.body.classList.add('ui-active');

    var video = document.getElementById("myVideo");

    // var source = $(video).find('source:first');
    // console.log(source.attr('data-src'));
    if (!this.is_mobile) {
      $(video).attr('src', $(video).attr('data-src'));


      var audioButton = document.querySelector('[data-role="audio-video-controller"]');
      audioButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleMute();
      });

      this.beScrollAware();

      if (!this.is_touch_device()) {
        //When this is not a touch device, set timer that will disable ui after 3 seconds of inactive mouse
        this.setMouseTimer();
        window.scrollTo(0, 0);
        document.body.classList.add('playing');
        // document.body.classList.add('no-scroll');
        video.addEventListener('ended', this.hideVideo, false);

        canAutoPlay.video({timeout: 700, muted: false}).then(({result}) => {
          if (result === true) {
            // Can autoplay
            // we do nothing
          } else {
            // Can not autoplay
            // mute it, on non touch it will work
            this.toggleMute();
          }
        });
      } else {
        document.body.classList.add('touch');
        // this.toggleMute();  // touch device, no sound at all on load
      }

      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.startVideo();
      });

    }

  }

  mobilecheck() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  beScrollAware() {
    let self = this;
    $(window).on('scroll', function() {
      let scrollPosition = $(this).scrollTop();
      if (scrollPosition >= 100) {
        $(this).off('scroll');
        self.startVideo();
      }
    });
  }

  toggleMute(){
    var video = document.getElementById("myVideo");
    if(video.muted){
      video.muted = false;
      document.body.classList.remove('muted');
    }else{
      video.muted = true;
      document.body.classList.add('muted');
    }
  }

  startVideo() {
    var video = document.getElementById("myVideo");

   if (this.is_touch_device()) {
      this.enterFullScreen();
      video.addEventListener('webkitfullscreenchange', this.changeFullScreenStatus.bind(this), false);
      video.addEventListener('mozfullscreenchange', this.changeFullScreenStatus.bind(this), false);
      video.addEventListener('fullscreenchange', this.changeFullScreenStatus.bind(this), false);
      video.addEventListener('MSFullscreenChange', this.changeFullScreenStatus.bind(this), false);
      video.addEventListener('ended', this.exitFullScreen, false);
   } else {
     if(video.paused){
       window.scrollTo(0, 0);
       video.play();
       this.beScrollAware();
       // document.body.classList.add('no-scroll');
       document.body.classList.add('playing');
     }else{
       video.pause();
       // document.body.classList.remove('no-scroll');
       document.body.classList.remove('playing');
     }

     video.addEventListener('ended', this.hideVideo, false);
   }
  }

  hideVideo(){ // end the video
    var video = document.getElementById("myVideo");
    video.pause();
    video.currentTime = 0;
    video.style.display = "none";

    document.querySelector('[data-role="home-video-buttons"]').classList.add('home-video-button-constrainer--hide');
    document.querySelector('.page-content').classList.add('page-content--video-finished');

    document.body.classList.remove("ui-inactive");
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('playing');
  }

  setMouseTimer() {
    var timer = window.setTimeout(fadeContent, 3000);
    var video = document.getElementById("myVideo");

    window.addEventListener('mousemove', resetMouseTimer);
    window.addEventListener('keypress', resetMouseTimer);

    function fadeContent() {
      if(!video.paused && !video.ended){
        document.body.classList.add("ui-inactive");
      }else if(video.ended){
        window.clearTimeout(timer);
      }
    }

    function resetMouseTimer() {
      window.clearTimeout(timer);
      timer = window.setTimeout(fadeContent, 3000);
      document.body.classList.remove("ui-inactive");
    }
  };

  exitFullScreen(){
    //TODO: doesn't work in Samsung built-in browser

    var video = document.getElementById("myVideo");

    if(video.mozCancelFullScreen) {
      video.mozCancelFullScreen();
    } else if(video.webkitExitFullscreen()) {
      video.webkitExitFullscreen();
    }else if(video.exitFullScreen) {
      video.exitFullScreen();
    }else{
      video.webkitCancelFullScreen();
    }
  }

  changeFullScreenStatus(){
    var video = document.getElementById("myVideo");

    if (this.isShowingFullScreen){
      if(!video.paused){
        video.pause();
      }
      this.isShowingFullScreen = false;
    }else if(!this.isShowingFullScreen) {
      this.isShowingFullScreen = true;
    }
  }

  is_touch_device() {
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    }
    return false;
  }

  enterFullScreen() {
    var videoElement = document.getElementById("myVideo");

    if (videoElement.mozRequestFullScreen) {
      videoElement.mozRequestFullScreen();
    } else if(videoElement.webkitEnterFullscreen) {
     videoElement.webkitEnterFullscreen();
    }else if(videoElement.requestFullscreen()) {
      videoElement.requestFullscreen();
    }else{
     videoElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
    }

    videoElement.play();
  }


}
